import { findCountryByCode } from "./countries";

export const SUPPORTED_LANGUAGES = [
  { code: "en", name: "English" },
  { code: "es", name: "Español" },
  { code: "zh", name: "中文" },
  { code: "hi", name: "हिन्दी" },
  { code: "ar", name: "العربية" },
  { code: "fr", name: "Français" },
  { code: "pt", name: "Português" },
  { code: "ja", name: "日本語" },
  { code: "de", name: "Deutsch" },
  { code: "vi", name: "Tiếng Việt" },
  { code: "ko", name: "한국어" },
  { code: "ru", name: "Русский" },
  { code: "it", name: "Italiano" },
  { code: "tr", name: "Türkçe" },
  { code: "id", name: "Bahasa Indonesia" },
  { code: "th", name: "ไทย" },
  { code: "bn", name: "বাংলা" },
  { code: "pl", name: "Polski" },
  { code: "nl", name: "Nederlands" },
  { code: "uk", name: "Українська" },
  { code: "ur", name: "اردو" },
  { code: "my", name: "မြန်မာ" },
  { code: "fa", name: "فارسی" },
  { code: "he", name: "עברית" },
  { code: "ms", name: "Bahasa Melayu" },
  { code: "fil", name: "Filipino" },
  { code: "ta", name: "தமிழ்" },
  { code: "sw", name: "Kiswahili" },
  { code: "ro", name: "Română" },
  { code: "el", name: "Ελληνικά" },
  { code: "cs", name: "Čeština" },
  { code: "hu", name: "Magyar" },
  { code: "sv", name: "Svenska" },
  { code: "fi", name: "Suomi" },
  { code: "km", name: "ខ្មែរ" },
  { code: "ne", name: "नेपाली" },
];

// Target-language value meaning "keep the spoken language": the media
// workflow skips its translate step.
export const AUTO_TARGET_LANGUAGE = "auto";

export const GOOGLE_TRANSLATE_LANGUAGES = {
  aa: "Afaraf",
  ab: "аҧсуа бызшәа",
  ace: "Basa Acèh",
  ach: "Lwo",
  af: "Afrikaans",
  ak: "Twi",
  alz: "Alur",
  am: "አማርኛ",
  ar: "العربية",
  as: "অসমীয়া",
  av: "авар мацӀ",
  awa: "अवधी",
  ay: "Aymar aru",
  az: "Azərbaycan dili",
  ba: "Башҡорт теле",
  bal: "بلوچی",
  ban: "ᬩᬲᬩᬮᬶ",
  bbc: "Batak Toba",
  bci: "Baoulé",
  be: "Беларуская",
  bem: "Ichibemba",
  ber: "ⵜⴰⵎⴰⵣⵉⵖⵜ",
  "ber-Latn": "Tamaziɣt",
  bew: "Bahasa Betawi",
  bg: "Български",
  bho: "भोजपुरी",
  bik: "Bikol",
  "bm-Nkoo": "NKo",
  bm: "Bamanankan",
  bn: "বাংলা",
  bo: "བོད་ཡིག",
  br: "Brezhoneg",
  bs: "Bosanski",
  bts: "Bahasa Simalungun",
  btx: "Cakap Karo",
  bua: "Буряад",
  ca: "Català",
  ce: "нохчийн мотт",
  ceb: "Cebuano",
  cgg: "Kiga",
  ch: "Chamoru",
  chk: "Chuukese",
  chm: "Марий йылме",
  ckb: "کوردی سۆرانی",
  cnh: "Hakha Chin",
  co: "Corsu",
  crh: "Qırımtatar tili",
  "crh-Latn": "Qırımtatar (Latin)",
  crs: "Kreol Seselwa",
  cs: "Čeština",
  cv: "Чӑваш чӗлхи",
  cy: "Cymraeg",
  da: "Dansk",
  de: "Deutsch",
  din: "Thuɔŋjäŋ",
  doi: "डोगरी",
  dov: "Dombe",
  dv: "ދިވެހި",
  dyu: "Dyula",
  dz: "རྫོང་ཁ",
  ee: "Eʋegbe",
  el: "Ελληνικά",
  en: "English",
  eo: "Esperanto",
  es: "Español",
  et: "Eesti",
  eu: "Euskara",
  fa: "فارسی",
  "fa-AF": "دری",
  ff: "Fulfulde",
  fi: "Suomi",
  fj: "Vosa Vakaviti",
  fo: "føroyskt",
  fon: "Fon",
  fr: "Français",
  "fr-CA": "Français (Canada)",
  fur: "Furlan",
  fy: "Frysk",
  ga: "Gaeilge",
  gaa: "Gã",
  gd: "Gàidhlig",
  gl: "Galego",
  gn: "Avañe'ẽ",
  gom: "कोंकणी",
  gu: "ગુજરાતી",
  gv: "Gaelg",
  ha: "Hausa",
  haw: "ʻŌlelo Hawaiʻi",
  hi: "हिन्दी",
  hil: "Hiligaynon",
  hmn: "Hmoob",
  hr: "Hrvatski",
  hrx: "Hunsrik",
  ht: "Kreyòl Ayisyen",
  hu: "Magyar",
  hy: "Հայերեն",
  iba: "Iban",
  id: "Bahasa Indonesia",
  ig: "Igbo",
  ilo: "Ilokano",
  is: "Íslenska",
  it: "Italiano",
  iu: "ᐃᓄᒃᑎᑐᑦ",
  "iu-Latn": "Inuktut (Latin)",
  iw: "עִברִית",
  ja: "日本語",
  jam: "Patois",
  jw: "Basa Jawa",
  ka: "ქართული",
  kac: "Jinghpaw",
  kg: "KiKongo",
  kha: "খাসি",
  kk: "Қазақ тілі",
  kl: "kalaallisut",
  km: "ខ្មែរ",
  kn: "ಕನ್ನಡ",
  ko: "한국어",
  kr: "Kanuri",
  kri: "Krio",
  ktu: "Kituba",
  ku: "Kurdî",
  kv: "коми кыв",
  ky: "Кыргызча",
  la: "Latina",
  lb: "Lëtzebuergesch",
  lg: "Luganda",
  li: "Limburgs",
  lij: "Líguru",
  lmo: "Lumbaart",
  ln: "Lingála",
  lo: "ລາວ",
  ltg: "Latgaļu",
  lua: "Tshiluba",
  luo: "Dholuo",
  lus: "Mizo ṭawng",
  lv: "Latviešu",
  mad: "Madhurâ",
  mai: "मैथिली",
  mak: "Basa Mangkasara",
  mam: "Mam",
  mfe: "Kreol morisien",
  mg: "Malagasy",
  mh: "Kajin M̧ajeļ",
  mi: "Te Reo Māori",
  min: "Baso Minangkabau",
  mk: "Македонски",
  ml: "മലയാളം",
  mn: "Монгол",
  "mni-Mtei": "মৈতৈলোন্",
  mr: "मराठी",
  ms: "Bahasa Melayu",
  "ms-Arab": "بهاس ملايو",
  mt: "Malti",
  mwr: "मारवाड़ी",
  my: "မြန်မာစာ",
  "ndc-ZW": "Ndau",
  ne: "नेपाली",
  new: "नेपाल भाषा",
  nhe: "Náhuatl",
  nl: "Nederlands",
  no: "Norsk",
  nr: "isiNdebele",
  nso: "Sepedi",
  nus: "Thok Nath",
  ny: "Chichewa",
  oc: "Occitan",
  om: "Afaan Oromoo",
  or: "ଓଡ଼ିଆ",
  os: "ирон æвзаг",
  pa: "ਪੰਜਾਬੀ",
  "pa-Arab": "پنجابی",
  pag: "Pangasinan",
  pam: "Kapampangan",
  pap: "Papiamento",
  pl: "Polski",
  ps: "پښتو",
  pt: "Português (Brasil)",
  "pt-PT": "Português (Portugal)",
  qu: "Runa Simi",
  kek: "Qʼeqchiʼ",
  rn: "Ikirundi",
  ro: "Română",
  rom: "Romani",
  ru: "Русский",
  rw: "Kinyarwanda",
  sa: "संस्कृतम्",
  sah: "Саха тыла",
  sat: "Santali (Ol Chiki)",
  "sat-Latn": "Santali (Latin)",
  scn: "Sicilianu",
  sd: "سنڌي",
  se: "Davvisámegiella",
  sg: "Sängö",
  shn: "ၽႃႇသႃႇတႆး",
  si: "සිංහල",
  sk: "Slovenčina",
  sl: "Slovenščina",
  sm: "Gagana Samoa",
  sn: "ChiShona",
  so: "Soomaali",
  sq: "Shqip",
  sr: "Српски",
  ss: "SiSwati",
  st: "Sesotho",
  su: "Basa Sunda",
  sus: "Sosoxui",
  sv: "Svenska",
  sw: "Kiswahili",
  szl: "Ślůnsko godka",
  ta: "தமிழ்",
  tcy: "ತುಳು",
  te: "తెలుగు",
  tet: "Tetun",
  tg: "Тоҷикӣ",
  th: "ไทย",
  ti: "ትግርኛ",
  tiv: "Tiv",
  tk: "Türkmen dili",
  tl: "Filipino",
  tn: "Setswana",
  to: "Faka Tonga",
  tpi: "Tok Pisin",
  tr: "Türkçe",
  trp: "Kokborok",
  ts: "Xitsonga",
  tt: "Татарча",
  tum: "chiTumbuka",
  ty: "Reo Tahiti",
  tyv: "Тыва дыл",
  udm: "Удмурт",
  ug: "ئۇيغۇرچە",
  uk: "Українська",
  ur: "اردو",
  uz: "O'zbek tili",
  ve: "Tshivenḓa",
  vec: "Vèneto",
  vi: "Tiếng Việt",
  war: "Winaray",
  wo: "Wolof",
  xh: "isiXhosa",
  yi: "ייִדיש",
  yo: "Yorùbá",
  yua: "Maaya t'aan",
  yue: "廣州話",
  zap: "Diidxazá",
  "zh-CN": "简体中文",
  "zh-TW": "繁體中文",
  zu: "isiZulu",
};

export const LANGUAGES: Record<string, { name: string; nativeName: string }> = {
  ab: { name: "Abkhaz", nativeName: "аҧсуа" },
  aa: { name: "Afar", nativeName: "Afaraf" },
  af: { name: "Afrikaans", nativeName: "Afrikaans" },
  ak: { name: "Akan", nativeName: "Akan" },
  sq: { name: "Albanian", nativeName: "Shqip" },
  am: { name: "Amharic", nativeName: "አማርኛ" },
  ar: { name: "Arabic", nativeName: "العربية" },
  an: { name: "Aragonese", nativeName: "Aragonés" },
  hy: { name: "Armenian", nativeName: "Հայերեն" },
  as: { name: "Assamese", nativeName: "অসমীয়া" },
  av: { name: "Avaric", nativeName: "авар мацӀ, магӀарул мацӀ" },
  ae: { name: "Avestan", nativeName: "avesta" },
  ay: { name: "Aymara", nativeName: "aymar aru" },
  az: { name: "Azerbaijani", nativeName: "azərbaycan dili" },
  bm: { name: "Bambara", nativeName: "bamanankan" },
  ba: { name: "Bashkir", nativeName: "башҡорт теле" },
  eu: { name: "Basque", nativeName: "euskara, euskera" },
  be: { name: "Belarusian", nativeName: "Беларуская" },
  bn: { name: "Bengali", nativeName: "বাংলা" },
  bh: { name: "Bihari", nativeName: "भोजपुरी" },
  bho: { name: "Bhojpuri", nativeName: "भोजपुरी" },
  bi: { name: "Bislama", nativeName: "Bislama" },
  bs: { name: "Bosnian", nativeName: "bosanski jezik" },
  br: { name: "Breton", nativeName: "brezhoneg" },
  bg: { name: "Bulgarian", nativeName: "български език" },
  my: { name: "Burmese", nativeName: "ဗမာစာ" },
  ca: { name: "Catalan", nativeName: "Català" },
  ch: { name: "Chamorro", nativeName: "Chamoru" },
  ce: { name: "Chechen", nativeName: "нохчийн мотт" },
  ny: { name: "Nyanja", nativeName: "chiCheŵa, chinyanja" },
  zh: { name: "Chinese", nativeName: "中文 (Zhōngwén), 汉语, 漢語" },
  cv: { name: "Chuvash", nativeName: "чӑваш чӗлхи" },
  kw: { name: "Cornish", nativeName: "Kernewek" },
  co: { name: "Corsican", nativeName: "corsu, lingua corsa" },
  cr: { name: "Cree", nativeName: "ᓀᐦᐃᔭᐍᐏᐣ" },
  crs: { name: "Seselwa Creole French", nativeName: "Kreolɛn Séléwɛ" },
  hr: { name: "Croatian", nativeName: "hrvatski" },
  cs: { name: "Czech", nativeName: "česky, čeština" },
  da: { name: "Danish", nativeName: "dansk" },
  dv: { name: "Dhivehi", nativeName: "ދިވެހި" },
  dz: { name: "Dzongkha", nativeName: "རྫོང་ཁ" },
  nl: { name: "Dutch", nativeName: "Nederlands, Vlaams" },
  en: { name: "English", nativeName: "English" },
  eo: { name: "Esperanto", nativeName: "Esperanto" },
  et: { name: "Estonian", nativeName: "eesti, eesti keel" },
  ee: { name: "Ewe", nativeName: "Eʋegbe" },
  fo: { name: "Faroese", nativeName: "føroyskt" },
  fj: { name: "Fijian", nativeName: "vosa Vakaviti" },
  fi: { name: "Finnish", nativeName: "suomi, suomen kieli" },
  fr: { name: "French", nativeName: "français, langue française" },
  ff: {
    name: "Fula; Fulah; Pulaar; Pular",
    nativeName: "Fulfulde, Pulaar, Pular",
  },
  gl: { name: "Galician", nativeName: "Galego" },
  ka: { name: "Georgian", nativeName: "ქართული" },
  de: { name: "German", nativeName: "Deutsch" },
  el: { name: "Greek", nativeName: "Ελληνικά" },
  gn: { name: "Guaraní", nativeName: "Avañeʼẽ" },
  gu: { name: "Gujarati", nativeName: "ગુજરાતી" },
  ht: { name: "Haitian Creole", nativeName: "Kreyòl ayisyen" },
  ha: { name: "Hausa", nativeName: "Hausa, هَوُسَ" },
  haw: { name: "Hawaiian", nativeName: "ʻŌlelo Hawaiʻi" },
  he: { name: "Hebrew (modern)", nativeName: "עברית" },
  hz: { name: "Herero", nativeName: "Otjiherero" },
  hi: { name: "Hindi", nativeName: "हिन्दी, हिंदी" },
  ho: { name: "Hiri Motu", nativeName: "Hiri Motu" },
  hu: { name: "Hungarian", nativeName: "Magyar" },
  ia: { name: "Interlingua", nativeName: "Interlingua" },
  id: { name: "Indonesian", nativeName: "Bahasa Indonesia" },
  ie: {
    name: "Interlingue",
    nativeName: "Originally called Occidental; then Interlingue after WWII",
  },
  ga: { name: "Irish", nativeName: "Gaeilge" },
  gaa: { name: "Ga", nativeName: "Ga" },
  ig: { name: "Igbo", nativeName: "Asụsụ Igbo" },
  ik: { name: "Inupiaq", nativeName: "Iñupiaq, Iñupiatun" },
  io: { name: "Ido", nativeName: "Ido" },
  is: { name: "Icelandic", nativeName: "Íslenska" },
  it: { name: "Italian", nativeName: "Italiano" },
  iu: { name: "Inuktitut", nativeName: "ᐃᓄᒃᑎᑐᑦ" },
  ja: { name: "Japanese", nativeName: "日本語 (にほんご／にっぽんご)" },
  jv: { name: "Javanese", nativeName: "basa Jawa" },
  kl: {
    name: "Kalaallisut, Greenlandic",
    nativeName: "kalaallisut, kalaallit oqaasii",
  },
  kha: { name: "Khasi", nativeName: "Khasi" },
  kn: { name: "Kannada", nativeName: "ಕನ್ನಡ" },
  kr: { name: "Kanuri", nativeName: "Kanuri" },
  ks: { name: "Kashmiri", nativeName: "कश्मीरी, كشميري‎" },
  kk: { name: "Kazakh", nativeName: "Қазақ тілі" },
  km: { name: "Khmer", nativeName: "ភាសាខ្មែរ" },
  ki: { name: "Kikuyu, Gikuyu", nativeName: "Gĩkũyũ" },
  kri: { name: "Krio", nativeName: "Krio" },
  rw: { name: "Kinyarwanda", nativeName: "Ikinyarwanda" },
  ky: { name: "Kirghiz, Kyrgyz", nativeName: "кыргыз тили" },
  kv: { name: "Komi", nativeName: "коми кыв" },
  kg: { name: "Kongo", nativeName: "KiKongo" },
  ko: { name: "Korean", nativeName: "한국어 (韓國語), 조선말 (朝鮮語)" },
  ku: { name: "Kurdish", nativeName: "Kurdî, كوردی‎" },
  kj: { name: "Kwanyama, Kuanyama", nativeName: "Kuanyama" },
  la: { name: "Latin", nativeName: "latine, lingua latina" },
  lb: { name: "Luxembourgish", nativeName: "Lëtzebuergesch" },
  lg: { name: "Luganda", nativeName: "Luganda" },
  li: { name: "Limburgish, Limburgan, Limburger", nativeName: "Limburgs" },
  ln: { name: "Lingala", nativeName: "Lingála" },
  lo: { name: "Lao", nativeName: "ພາສາລາວ" },
  lt: { name: "Lithuanian", nativeName: "lietuvių kalba" },
  lu: { name: "Luba-Katanga", nativeName: "Kilubà" },
  lua: { name: "Luba-Lulua", nativeName: "Cilubà" },
  luo: { name: "Luo", nativeName: "Dholuo" },
  lv: { name: "Latvian", nativeName: "latviešu valoda" },
  gv: { name: "Manx", nativeName: "Gaelg, Gailck" },
  mk: { name: "Macedonian", nativeName: "македонски јазик" },
  mg: { name: "Malagasy", nativeName: "Malagasy fiteny" },
  ms: { name: "Malay", nativeName: "bahasa Melayu, بهاس ملايو‎" },
  ml: { name: "Malayalam", nativeName: "മലയാളം" },
  mt: { name: "Maltese", nativeName: "Malti" },
  mi: { name: "Māori", nativeName: "te reo Māori" },
  mr: { name: "Marathi (Marāṭhī)", nativeName: "मराठी" },
  mh: { name: "Marshallese", nativeName: "Kajin M̧ajeļ" },
  mn: { name: "Mongolian", nativeName: "монгол" },
  mfe: { name: "Morisyen", nativeName: "Kreol Morisien" },
  na: { name: "Nauru", nativeName: "Ekakairũ Naoero" },
  nv: { name: "Navajo, Navaho", nativeName: "Diné bizaad, Dinékʼehǰí" },
  nb: { name: "Norwegian Bokmål", nativeName: "Norsk bokmål" },
  nd: { name: "North Ndebele", nativeName: "isiNdebele" },
  ne: { name: "Nepali", nativeName: "नेपाली" },
  new: { name: "Newari", nativeName: "नेपाल भाषा" },
  ng: { name: "Ndonga", nativeName: "Owambo" },
  nn: { name: "Norwegian Nynorsk", nativeName: "Norsk nynorsk" },
  no: { name: "Norwegian", nativeName: "Norsk" },
  nso: { name: "Northern Sotho", nativeName: "Sepedi" },
  ii: { name: "Nuosu", nativeName: "ꆈꌠ꒿ Nuosuhxop" },
  nr: { name: "South Ndebele", nativeName: "isiNdebele" },
  oc: { name: "Occitan", nativeName: "Occitan" },
  oj: { name: "Ojibwe, Ojibwa", nativeName: "ᐊᓂᔑᓈᐯᒧᐎᓐ" },
  cu: {
    name: "Old Church Slavonic, Church Slavic, Church Slavonic, Old Bulgarian, Old Slavonic",
    nativeName: "ѩзыкъ словѣньскъ",
  },
  om: { name: "Oromo", nativeName: "Afaan Oromoo" },
  or: { name: "Oriya", nativeName: "ଓଡ଼ିଆ" },
  os: { name: "Ossetian, Ossetic", nativeName: "ирон æвзаг" },
  pa: { name: "Panjabi, Punjabi", nativeName: "ਪੰਜਾਬੀ, پنجابی‎" },
  pam: { name: "Pampanga", nativeName: "Kapampangan" },
  pi: { name: "Pāli", nativeName: "पाऴि" },
  fa: { name: "Persian", nativeName: "فارسی" },
  pl: { name: "Polish", nativeName: "polski" },
  ps: { name: "Pashto, Pushto", nativeName: "پښتو" },
  pt: { name: "Portuguese", nativeName: "Português" },
  "pt-PT": {
    name: "Portuguese (Portugal)",
    nativeName: "Português (Portugal)",
  },
  "pt-BR": { name: "Portuguese (Brazil)", nativeName: "Português (Brasil)" },
  qu: { name: "Quechua", nativeName: "Runa Simi, Kichwa" },
  rm: { name: "Romansh", nativeName: "rumantsch grischun" },
  rn: { name: "Kirundi", nativeName: "kiRundi" },
  ro: { name: "Romanian", nativeName: "română" },
  ru: { name: "Russian", nativeName: "русский язык" },
  sa: { name: "Sanskrit (Saṁskṛta)", nativeName: "संस्कृतम्" },
  sc: { name: "Sardinian", nativeName: "sardu" },
  sd: { name: "Sindhi", nativeName: "सिन्धी, سنڌي، سندھی‎" },
  se: { name: "Northern Sami", nativeName: "Davvisámegiella" },
  sm: { name: "Samoan", nativeName: "gagana faa Samoa" },
  sg: { name: "Sango", nativeName: "yângâ tî sängö" },
  sr: { name: "Serbian", nativeName: "српски језик" },
  gd: { name: "Gaelic", nativeName: "Gàidhlig" },
  sn: { name: "Shona", nativeName: "chiShona" },
  si: { name: "Sinhala, Sinhalese", nativeName: "සිංහල" },
  sk: { name: "Slovak", nativeName: "slovenčina" },
  sl: { name: "Slovene", nativeName: "slovenščina" },
  so: { name: "Somali", nativeName: "Soomaaliga, af Soomaali" },
  st: { name: "Southern Sotho", nativeName: "Sesotho" },
  es: { name: "Spanish", nativeName: "español, castellano" },
  "es-AR": { name: "Spanish (Argentina)", nativeName: "español de Argentina" },
  "es-CO": { name: "Spanish (Colombia)", nativeName: "español de Colombia" },
  "es-PE": { name: "Spanish (Peru)", nativeName: "español de Perú" },
  "es-CL": { name: "Spanish (Chile)", nativeName: "español de Chile" },
  "es-PT": { name: "Spanish (Portugal)", nativeName: "español de Portugal" },
  "es-PR": {
    name: "Spanish (Puerto Rico)",
    nativeName: "español de Puerto Rico",
  },
  "es-DO": {
    name: "Spanish (Dominican Republic)",
    nativeName: "español de República Dominicana",
  },
  "es-EC": { name: "Spanish (Ecuador)", nativeName: "español de Ecuador" },
  "es-SV": {
    name: "Spanish (El Salvador)",
    nativeName: "español de El Salvador",
  },
  "es-GT": { name: "Spanish (Guatemala)", nativeName: "español de Guatemala" },
  "es-HN": { name: "Spanish (Honduras)", nativeName: "español de Honduras" },
  "es-NI": { name: "Spanish (Nicaragua)", nativeName: "español de Nicaragua" },
  "es-PA": { name: "Spanish (Panama)", nativeName: "español de Panamá" },
  "es-PY": { name: "Spanish (Paraguay)", nativeName: "español de Paraguay" },
  "es-UY": { name: "Spanish (Uruguay)", nativeName: "español de Uruguay" },
  "es-VE": { name: "Spanish (Venezuela)", nativeName: "español de Venezuela" },
  "es-BO": { name: "Spanish (Bolivia)", nativeName: "español de Bolivia" },
  "es-CR": {
    name: "Spanish (Costa Rica)",
    nativeName: "español de Costa Rica",
  },
  "es-CU": { name: "Spanish (Cuba)", nativeName: "español de Cuba" },
  "es-HT": { name: "Spanish (Haiti)", nativeName: "español de Haití" },
  "es-MX": { name: "Spanish (Mexico)", nativeName: "español de México" },
  "es-ES": { name: "Spanish (Spain)", nativeName: "español de España" },
  "es-US": {
    name: "Spanish (United States)",
    nativeName: "español de Estados Unidos",
  },
  su: { name: "Sundanese", nativeName: "Basa Sunda" },
  sw: { name: "Swahili", nativeName: "Kiswahili" },
  ss: { name: "Swati", nativeName: "SiSwati" },
  sv: { name: "Swedish", nativeName: "svenska" },
  ta: { name: "Tamil", nativeName: "தமிழ்" },
  te: { name: "Telugu", nativeName: "తెలుగు" },
  tg: { name: "Tajik", nativeName: "тоҷикӣ, toğikī, تاجیکی‎" },
  th: { name: "Thai", nativeName: "ไทย" },
  ti: { name: "Tigrinya", nativeName: "ትግርኛ" },
  bo: { name: "Tibetan Standard, Tibetan, Central", nativeName: "བོད་ཡིག" },
  tk: { name: "Turkmen", nativeName: "Türkmen, Түркмен" },
  tl: { name: "Tagalog", nativeName: "Wikang Tagalog, ᜏᜒᜃᜅ᜔ ᜆᜄᜎᜓᜄ᜔" },
  tn: { name: "Tswana", nativeName: "Setswana" },
  to: { name: "Tonga (Tonga Islands)", nativeName: "faka Tonga" },
  tr: { name: "Turkish", nativeName: "Türkçe" },
  ts: { name: "Tsonga", nativeName: "Xitsonga" },
  tt: { name: "Tatar", nativeName: "татарча, tatarça, تاتارچا‎" },
  tw: { name: "Twi", nativeName: "Twi" },
  tum: { name: "Tumbuka", nativeName: "Chitumbuka" },
  ty: { name: "Tahitian", nativeName: "Reo Tahiti" },
  ug: { name: "Uighur, Uyghur", nativeName: "Uyƣurqə, ئۇيغۇرچە‎" },
  uk: { name: "Ukrainian", nativeName: "українська" },
  ur: { name: "Urdu", nativeName: "اردو" },
  uz: { name: "Uzbek", nativeName: "zbek, Ўзбек, أۇزبېك‎" },
  ve: { name: "Venda", nativeName: "Tshivenḓa" },
  vi: { name: "Vietnamese", nativeName: "Tiếng Việt" },
  vo: { name: "Volapük", nativeName: "Volapük" },
  wa: { name: "Walloon", nativeName: "Walon" },
  war: { name: "Waray", nativeName: "Winaray" },
  cy: { name: "Welsh", nativeName: "Cymraeg" },
  wo: { name: "Wolof", nativeName: "Wollof" },
  fy: { name: "Western Frisian", nativeName: "Frysk" },
  xh: { name: "Xhosa", nativeName: "isiXhosa" },
  yi: { name: "Yiddish", nativeName: "ייִדיש" },
  yo: { name: "Yoruba", nativeName: "Yorùbá" },
  za: { name: "Zhuang, Chuang", nativeName: "Saɯ cueŋƅ, Saw cuengh" },
  ceb: { name: "Cebuano", nativeName: "Sinugboanon" },
  "zh-Hant": { name: "Chinese Traditional", nativeName: "繁體中文" },
  "zh-Hans": { name: "Chinese Simplified", nativeName: "简体中文" },
  fil: { name: "Filipino", nativeName: "Filipino" },
  iw: { name: "Hebrew", nativeName: "עברית" },
  hmn: { name: "Hmong", nativeName: "Hmoob" },
  zu: { name: "Zulu", nativeName: "isiZulu" },
  "en-GB": { name: "English (United Kingdom)", nativeName: "English" },
  "zh-CN": { name: "Chinese (Simplified)", nativeName: "简体中文" },
  "zh-cn": { name: "Chinese (Simplified)", nativeName: "简体中文" },
  ag: { name: "Anglosaxon", nativeName: "Ænglisc" },
  mo: { name: "Moldoveana", nativeName: "Moldovenească" },
  sh: { name: "Srpskohrvatski", nativeName: "Српскохрватски" },
  zt: { name: "Traditional Chinese", nativeName: "繁體中文" },
  "en-US": { name: "English (United States)", nativeName: "English" },
  gan: { name: "赣语", nativeName: "赣语" },
  hm: { name: "Hmong", nativeName: "Hmoob" },
  nh: { name: "Nahuatl", nativeName: "Nāhuatl" },
  "zh-tw": { name: "Chinese (Traditional)", nativeName: "中文(台灣)" },
  "zh-TW": { name: "Chinese (Traditional)", nativeName: "中文(台灣)" },
  hat: { name: "Kreyòl Ayisyen", nativeName: "Kreyòl ayisyen" },
  mne: { name: "Montenegrin", nativeName: "Crnogorski" },
  at: { name: "Asturianu", nativeName: "Asturianu" },
  lol: { name: "lolspeak", nativeName: "lolspeak" },
  mu: { name: "Karaoke", nativeName: "Karaoke" },
  nya: { name: "Nyanja", nativeName: "chiCheŵa, chinyanja" },
  mya: { name: "Burmese 2", nativeName: "ဗမာစာ" },
  "zh-hans": { name: "Chinese Simplified", nativeName: "中文" },
};

/**
 * Resolve a language code to {name, nativeName}, handling region/script-suffixed
 * codes (nl-NL, fr_FR, de-DE) that lack a dedicated LANGUAGES entry by falling
 * back to the base language + country name -> "Dutch (Netherlands)". Full-code
 * entries (pt-BR, en-US, zh-TW) still win.
 */
export const getLanguageInfo = (
  code: string
): { name: string; nativeName: string } => {
  if (!code) return { name: code, nativeName: code };
  if (LANGUAGES[code]) return LANGUAGES[code];
  const lower = code.toLowerCase();
  if (LANGUAGES[lower]) return LANGUAGES[lower];

  const m = code.match(/^([a-zA-Z]{2,3})[-_](.+)$/);
  if (m) {
    const base = LANGUAGES[m[1].toLowerCase()];
    if (base) {
      const country = findCountryByCode(m[2].toUpperCase());
      return country
        ? { name: `${base.name} (${country.name})`, nativeName: base.nativeName }
        : base;
    }
  }
  return { name: code, nativeName: code };
};

export const getLanguageDisplayName = (code: string): string =>
  getLanguageInfo(code).name;
